export default __webpack_public_path__ + "static/media/eastern-rubber.b63ac6e9.webp";